import { Box, Divider, Fade, Grid, Paper, Popper, Typography } from "@mui/material"
import {Calendar, DateObject} from "react-multi-date-picker"
// import gregorian_es from "react-date-object/locales/gregorian_es"
import { useEffect, useState } from "react";

import "./index.css"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { searchEmployeeCalendarEvents } from "../../../store/slices/userRequests";
import { CouponStatus } from "../../../enumns/Coupons";
import { useTheme } from '@mui/material/styles';
import { EmployeCoupons } from "../../../interfaces/employeeDocuments.interface";

const gregorian_es = {
    name: "gregorian_es",
    months: [
      ["Enero", "Ene"],
      ["Febrero", "Feb"],
      ["Marzo", "Mar"],
      ["Abril", "Abr"],
      ["Mayo", "May"],
      ["Junio", "Jun"],
      ["Julio", "Jul"],
      ["Agosto", "Ago"],
      ["Septiembre", "Sep"],
      ["Octubre", "Oct"],
      ["Noviembre", "Nov"],
      ["Diciembre", "Dic"],
    ],
    weekDays: [
      ["Sábado", "Sab"],
      ["Domingo", "Dom"],
      ["Lunes", "Lun"],
      ["Martes", "Mar"],
      ["Miércoles", "Mie"],
      ["Jueves", "Jue"],
      ["Viernes", "Vie"],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
      ["AM", "am"],
      ["PM", "pm"],
    ],
}


interface GroupedEvent {
    [month: number]: Date[];
}

interface BirthdayProps {
    name: string;
    date: string; // formateada como "YYYY-MM-DD"
}


const someDayEvent = (date: Date, b: any) => {
  const aniversary = new Date(b.date);
  const month = aniversary.getMonth();
  const day = aniversary.getDate();
  const selectedMonth = date.getMonth();
  const selectedDay = date.getDate();
  const isValid = day === selectedDay && month === selectedMonth;
  return isValid;
}

const isHoliday = (event: any) => event.State === undefined;

const getEventColor = (state: CouponStatus): string => {
  switch(state) {
    case CouponStatus.Aprobados: return '#A5D6A7';
    case CouponStatus.Rechazados: return '#FFCDD2';
    case CouponStatus.Pendientes: return '#FFF9C4';
    // case CouponStatus['Aprobados por utilizar']: return '#90CAF9';
    default: return 'inherit';
  }
};

const getDayStyles = (date: Date, events: any[]) => {
  const baseStyles = {
    borderRadius: '40px',
    width: '100%',
    aspectRatio: '1 / 1',
    textAlign: 'center' as const,
    cursor: 'pointer',
    position: 'relative' as const,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
    alignItems: 'center'
  } as any;

  const dayEvents = events.filter(event => someDayEvent(date, event));
  const holiday = dayEvents.find(isHoliday);
  const coupons = dayEvents.filter(e => !isHoliday(e));
  const uniqueStates = Array.from(new Set(coupons.map(c => c.State)));

  if (dayEvents.length === 0) {
    return baseStyles;
  }

  if (holiday && coupons.length === 0) {
    return {
      ...baseStyles,
      backgroundColor: '#CE93D8',
      color: 'white'
    };
  }

  const styles = { ...baseStyles };

  // if (uniqueStates.length === 1) {
  //   styles.backgroundColor = getEventColor(uniqueStates[0]);
  //   if (holiday) {
  //     styles.background = `linear-gradient(135deg, #CE93D8 30%, ${getEventColor(uniqueStates[0])} 30%)`;
  //   }
  // } else 
  if (uniqueStates.length > 0) {
    const colors = uniqueStates.map(getEventColor);
    if (holiday) colors.unshift('#CE93D8');
    const percentage = 100 / colors.length;
    styles.background = `linear-gradient(${
      colors.map((color, i) => 
        `${color} ${i * percentage}%, ${color} ${(i + 1) * percentage}%`
      ).join(', ')
    })`;
  }

  return styles;
};

const MonthCalendar = ({events, ...props}: any) => {
  
  const {s10palette} = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [open, setOpen] = useState(false);

  const handleDateClick = (event: React.MouseEvent<HTMLDivElement>, date: DateObject) => {
    const utcDate = new Date(
      date.year,
      date.month.index,
      date.day
    );
    const hasBirthday = events?.some((b: any) => someDayEvent(utcDate, b));

    if (hasBirthday) {
      setAnchorEl(event.currentTarget);
      setSelectedDate(utcDate);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };


  const selectedBirthdays = events?.filter((b: BirthdayProps) => selectedDate && someDayEvent(selectedDate, b));

  return (
    <div>
      <Calendar
        locale={gregorian_es}
        {...props}
        mapDays={({ date }) => {
          const utcDate = new Date(
            date.year,
            date.month.index,
            date.day
          );
          return {
              style: getDayStyles(utcDate, events),
              onClick: (event: React.MouseEvent<HTMLDivElement>) => handleDateClick(event, date),
              onMouseLeave: handleClose,
              onMouseEnter: (event: React.MouseEvent<HTMLDivElement>) => handleDateClick(event, date),
          };
        }}
      />
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="right-end"
        transition
        onMouseLeave={handleClose}
        modifiers={[
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
              padding: 10,
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={3} style={{ padding: '10px' }}>
              {selectedBirthdays.length > 0 ? (
                selectedBirthdays.map((data: EmployeCoupons, i: number) => (
                  <Grid key={data.customId} container item style={{width: "100%"}} direction={"row"}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                        item 
                        style={{
                            flex: 1,
                            width: "100%",
                            marginLeft: ".5rem"
                        }}
                    >
                        <Typography variant="subtitle2" color={s10palette.S10Greygrey700}>
                          {data.Name}
                        </Typography>
                        <Typography variant="subtitle1" fontSize={"0.75rem"} color={s10palette.S10Greygrey500}>
                          {data.RangeDateInfo.split(' ')[0]}
                        </Typography>
                        {data.StateDescription && 
                          <Typography variant="subtitle1" fontSize={"0.75rem"} color={s10palette.S10Greygrey500}>
                            Estado {data.StateDescription}
                          </Typography>
                        }
                    </Grid>
                    {selectedBirthdays.length > 1 && selectedBirthdays.length > (i + 1) && <Divider 
                      style={{
                        width: "100%", 
                        marginTop: ".5rem", 
                        marginBottom: ".5rem",
                        color: "#E8E8E8",
                      }}
                    />}
                  </Grid>
                ))
              ) : (
                <Typography>No hay cumpleaños en esta fecha.</Typography>
              )}
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

const ColorLegend = () => {
  const legendItems = [
    { color: '#A5D6A7', label: 'Aprobados' },
    // { color: '#90CAF9', label: 'Aprobados por utilizar' },
    { color: '#FFF9C4', label: 'Pendientes' },
    { color: '#FFCDD2', label: 'Rechazados' },
    { color: '#CE93D8', label: 'Días feriados' },
  ];

  return (
    <Paper elevation={1} sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>Leyenda</Typography>
      <Grid container spacing={2}>
        {legendItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box display="flex" alignItems="center">
              <Box
                width={24}
                height={24}
                borderRadius="4px"
                mr={1}
                sx={{ background: item.color, border: '1px solid #ddd' }}
              />
              <Typography variant="body2">{item.label}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

const MyCalendar = () => {
    
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, sessionData, connectionId} = useSelector((state: RootState) => state.auth);
    const {calendarEvents} = useSelector((state: RootState) => state.userRequests);
  
    const [groupedEvent, setGroupedEvent] = useState<GroupedEvent>();
    
    useEffect(() => {
        if (!calendarEvents?.length) {
            setGroupedEvent({});
            return;
        }

        const groupedByMonth = calendarEvents.reduce((acc: any, b) => {
          const aniversary = new Date(b.customDate);
          const month = aniversary.getMonth();
          if (!acc[month]) {
            acc[month] = [
            ];
            // TODO: this is only for test
            // if (month === 6) {
            //   console.log('month', calendarEvents
            //     .filter(c => [0, 5].includes(new Date(c.customDate).getMonth())))
              
            //   acc[month] = calendarEvents
            //     .filter(c => [0, 5].includes(new Date(c.customDate).getMonth()))
            //     .map(ce => {
            //       const customDate = ce.customDate.replace('-01-', '-07-').replace('-06-', '-07-')
            //       return {
            //         ...ce,
            //         customDate,
            //         date: customDate,
            //       }
            //     })
            //     console.log('month', acc[month] )
            // }
          }

          acc[month].push({
              ...b,
              name: b.Description,
              date: b.customDate,
              Id: b.customId,
          });
          return acc;
        }, {});
        setGroupedEvent(groupedByMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarEvents]);

    
    useEffect(() => {
        if (!companyselected || !sessionData || !connectionId) return;
        console.log("getting calendar")
        dispatch(searchEmployeeCalendarEvents())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId, companyselected, sessionData])

    return (
        <Grid container>
          {<ColorLegend />}
          <Grid
            container
            direction="row"
            width="100%"
            margin="1.5rem 0 0 0"
            minHeight="60%"
            spacing="1rem"
            justifyContent="space-between"
            position="relative"
          >
            {groupedEvent && [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
                const requiredDate = new DateObject().setMonth(month);
                const rmonth = requiredDate.month.number;
                const year = requiredDate.year;
                const startDate = new Date(year, rmonth - 1).setDate(1);
                const endDate = new Date(year, rmonth).setDate(-1);
                return (
                    <Grid item  xs={12} sm={6} md={3} lg={3} xl={3} key={month}>
                        <MonthCalendar
                            className="calendar"
                            currentDate={requiredDate}
                            minDate={startDate}
                            maxDate={endDate}
                            disableYearPicker={true}
                            disableMonthPicker={true}
                            readOnly={true}
                            hideYear={true}
                            events={(groupedEvent[month - 1] || []) as any}
                        />
                    </Grid>
                );
            })}
          </Grid>
        </Grid>
    )
}

export default MyCalendar;